import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./site.css";
import LandingPage from "./LandingPage";
import ProjectPage from "./ProjectPage";
import YtVidCreatorPage from "./YtVidCreatorPage";
import YtVidCreatorPrivacyPage from "./YtVidCreatorPrivacyPage";
import SiteFooter from "./components/SiteFooter";
import SiteHeader from "./components/SiteHeader";
import { LanguageProvider } from "./i18n";

function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const timer = window.setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
    return undefined;
  }, [pathname, hash]);

  return null;
}

function Site() {
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <ScrollManager />
      <SiteHeader />
      <div id="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ytvidcreator" element={<YtVidCreatorPage />} />
          <Route path="/ytvidcreator/tietosuoja" element={<YtVidCreatorPrivacyPage />} />
          <Route path="/projects/:slug" element={<ProjectPage />} />
          <Route path="*" element={<ProjectPage />} />
        </Routes>
      </div>
      <SiteFooter />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Site />
      </LanguageProvider>
    </BrowserRouter>
  );
}
